<header>
  <div class="bewp-dialog-header">
    <h3 mat-dialog-title class="bewp-dialog-header__title">Account closed</h3>
    <button class="bewp-close-btn" mat-dialog-close aria-label="Close">
      <app-icon-close width="16" height="16" color="#011835"></app-icon-close>
    </button>
  </div>
</header>

<mat-dialog-content>
  <p class="bewp-closed-message">
    <span class="bewp-font-medium"
      >{{ productType }}...{{ data.last4DigitsExternalAccountNumber }}</span
    >
    is closed. We are not able to service closed accounts online.
    <span class="bewp-font-medium"
      >Please call us at
      <a
        *ngIf="
          data.productType === 'Vehicle Equity Loan';
          else defaultPhoneNumber
        "
        class="bewp-closed-account-phone"
        href="tel:8662102842"
        >866-210-2842</a
      >
      for assistance.</span
    >
  </p>

  <div class="bewp-btn-group">
    <button mat-dialog-close class="bewp-btn bewp-btn--small">Okay</button>
  </div>
</mat-dialog-content>

<ng-template #defaultPhoneNumber
  ><a class="bewp-closed-account-phone" href="tel:8552826353"
    >855-282-6353</a
  ></ng-template
>
